
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.595 12.5c-.053-.004-.066-.003-.119-.012a.887.887 0 01-.47-.239L.756 7.106C.719 7.068.709 7.06.677 7.018a.847.847 0 010-1.036c.032-.041.042-.05.079-.088L6.006.751c.039-.035.048-.045.09-.077a.887.887 0 01.905-.09.865.865 0 01.494.685.843.843 0 01-.173.606c-.032.042-.042.05-.078.088L2.612 6.5l4.632 4.537.04.043c.034.04.044.05.073.093a.85.85 0 01.143.5.862.862 0 01-.726.815c-.053.009-.066.008-.12.012h-.059z","fill":"currentColor"}})])
          )
        }
      }
    